// (c) chaehongee. Confidential and proprietary.

import { useEffect } from 'react'
import type { WorldPointerDelegates, FramePointerDelegates, MarqueePointerDelegates, PointerDelegates } from '../features/viewport/types'

interface UsePointerDelegatesParams {
    setPointerDelegates: (delegates: PointerDelegates) => void
    worldDelegates: WorldPointerDelegates
    frameDelegates: FramePointerDelegates
    marqueeDelegates?: MarqueePointerDelegates
}

/**
 * Hook that coordinates pointer event delegation between Canvas features.
 * Wires up world item handlers, frame handlers, and marquee handlers to the viewport's pointer system.
 */
export function usePointerDelegates({
    setPointerDelegates,
    worldDelegates,
    frameDelegates,
    marqueeDelegates,
}: UsePointerDelegatesParams): void {
    useEffect(() => {
        setPointerDelegates({
            world: worldDelegates,
            frame: frameDelegates,
            marquee: marqueeDelegates ?? null,
        })
    }, [
        setPointerDelegates,
        worldDelegates.onPointerMove,
        worldDelegates.onPointerUp,
        worldDelegates.clearLocalSelection,
        frameDelegates.onPointerMove,
        frameDelegates.onPointerUp,
        marqueeDelegates?.startMarquee,
        marqueeDelegates?.moveMarquee,
        marqueeDelegates?.endMarquee,
    ])
}
